import { memo, useContext, useState } from "react";
import { Modal } from "react-bootstrap";
import CustomButton from "../component/button";
import { json, useNavigate } from "react-router-dom";
import { toastMsg } from "../component/toast";
import { AppContext } from "../context/AppContext";
import { ApiConfig } from "../Api/ApiConfig";
import { PostCallWithErrorResponse } from "../Api/ApiServices";
import AiExecutionLoader from "../component/AiExrcutionLoader";
import useSignalR from "../customHooks/useSignalR";

const PersonalityReoprtALert = memo((props) => {

    const { adminData } = useContext(AppContext)

    const {invoke} = useSignalR()

    const { isShowCandidateReport,
         setIsShowCandidateReport,
          userId, code, credits, userName, getList, candidateName, setCredits,setAccessCoeList,isLoading, setIsLoading,
          isGenerating,setIsGenarating,
          savePersonalityReport
        
     } = props



    


    const navigate = useNavigate()

    return (
        <>
            <Modal show={isShowCandidateReport}
                onHide={() => setIsShowCandidateReport(false)}
                centered
                size="md"
                dialogClassName="modal-h-650">
                <Modal.Body>
                    <div className="mt-2">
                        <div >
                            <h6 className="text-center interRegular">Are you sure you want to generate a detailed personality report for {userName}</h6>
                        </div>
                        <div className="d-flex justify-content-center gap-1">
                            <CustomButton
                                title="Yes"
                                isLoading={isGenerating}
                                handleClick={() => {

                                    if (credits[0]?.available == 0) {

                                        toastMsg('error', 'You can generate up to 25 detailed personality reports for each job. The limit for this job has already been reached. If you need to generate additional reports, please contact your LYWO representative.')
                                        return
                                    }
                                    savePersonalityReport()
                                    // navigate(`/DetailedPersonalityReport/${code}/${userId}`)
                                }}
                            />
                            <CustomButton
                                title="No"
                                buttonType='secondary'
                                handleClick={() => setIsShowCandidateReport(false)}
                            />

                        </div>
                        <div className="mt-2">
                            <h6 className="text-center interRegular">You can download a total of 25 reports per job.<br /> ({25-credits[0]?.available}/25 Already used)</h6>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <AiExecutionLoader 
            isOpen={isLoading}
            onDismiss={()=>setIsLoading(false)}
            totalDuration={180000}
            steps={[
                 "Analyzing your responses...",
                 "Mapping traits and behavior patterns...",
                 "Scoring key dimensions...",
                 "Generating your profile...",
                 "Reviewing for accuracy...",
                 'Finalizing your report...'
            ]}
            />
        </>
    )

})

export default PersonalityReoprtALert